import "./App.css";
import Login from "./Pages/Login/Login";
import {
  Routes,
  Route,
  BrowserRouter,
  Navigate,
  Outlet,
} from "react-router-dom";
import { Suspense } from "react";
import ProtectedRoute from "./routes/ProtectedRoute";
import AdminRoute from "./routes/AdminRoute";
import AppLoader from "./Components/Loader/AppLoader";

import {
  EmployeeTarget,
  AddCust,
  AddDar,
  AdmBranchPrincipalTargetList,
  AdmEditProductOperation,
  AdmPrincipal,
  AdmProduct,
  AdmProductOperation,
  ContinueDar,
  CreateQuotation,
  CustContact,
  CustList,
  DARSummary,
  Dashboard,
  EditCust,
  EditDar,
  EditEmployee,
  ViewEmployee,
  EmpChangePassword,
  EmployeeDepartment,
  EmployeeDesignation,
  EmpProduct,
  EmpTarget,
  FormQuotation,
  HolidayList,
  HrEmpDepart,
  HrEmpDesig,
  HrEmployeeList,
  HumanResource,
  KnowledgeShare,
  ManageHoliday,
  QuotationList,
  TargetEdit,
  ViewCust,
  ViewDar,
  HR,
  AddEmployee,
  AdmPrincipalTargetList,
  PrincipalTarget,
  QuarterMaster,
  AddQuarterMaster,
  AdmPrincipalQuarterName,
  AdmPrincipalQuarter,
  AdmPrincipalQuarterNameEdit,
  AdmBranchPrincipalTarget,
  OrderDefault,
  OrderGenerateList,
  OrderProcessedList,
  OrderGenerate,
  OrderProcessed,
  OrderProcessDefault,
  OPUApproval,
  OPUApprovalEdit,
  EngineerConfirmationList,
  EngineerConfirmationEdit,
  ActivityReport,
  AppDar,
  PriceList,
  MarkAttendance,
  AttendanceList,
  IndividualTarget,
  UserAttendanceList,
  LeaveRequest,
  LeaveHistory,
  WeeklyActivity,
  ManageProject,
  ProjectAllocation,
  ApproveActivity,
  AssignedProject,
  ActivityStatus,
  CurrencyMaster,
  // CustListISR,
  EmployeeLeaveDetail,
  AddNewEmployeeLeave,
  EmployeesLeaveRecord,
  AddSystemProperty,
  ITEquipment,
  ViewSystemDetail,
  EditSystemDetail,
  AssignEmployee,
  BackOfficeAppraisalForm,
  PsgAppraisalForm,
  FAEappraisalForm,
  MEAppraisalForm,
  PSGAppraisalForm,
  ModuleMaster,
  PreviousTraining,
  NewTraining,
  UpcomingTraining,
  Suggestions,
  Missed,
  Feedback,
  WeeklyReport,
  TrainingDetails,
  ManagerAudit,
  OrderDetails,
  AddOrderDetails,
  SentReviewForm,
  AppraisalNotFound,
  AppraisalDetail,
  EmpAppraisalForm,
  HrReview,
  CeoReview,
  CeoViewAppraisalForm,
  HrFinalReview,
  HrEmpViewAppraisalForm,
  ManageProjectType,
  ResetPassword,
  Reimbursement,
  ReimbursementList,
  MailModels,
  ManagerKRAapproval,
  MyKRA,
  AddModuleMaster,
  EmpConfirmation,
  ReportingHeadConfirmation,
  HRleaveandattendenceConfirmation,
  ViewDeviceInfo,
  CheckProbation,
  SubordinatesInfo,
  CustomerMaster,
  userSidesystemDetailView,
  UserSidesystemDetailView,
  DARActivityStatus,
  CompanyList,
  AddCompany,
  DARActivityMailMaster,
  OrderAnalytics,
  SubordinateLeaveHistory,
  ReportingHeadList,
  UserResignationStatus,
  QPI,
  OrderPipeline,
  QPIList,
  OrderPipelineList,
  ReviewPortal,
  SendLetter,
  ProjectReport,
  TargetsOverview,
  ExtraIncentive,
  ViewActivityReport,
  Forecast,
  Meddic,
  PerformanceOverview,
  EmployeeList,
  ApproveWeeklyActivity,
} from "./Router";

import Pdfhtml from "./Pages/ISR/PDFHtml/Pdfhtml";
import UserDataContextProvider from "./Context/UserDataContext/UserDataContextProvider";
import EmployeesGraph from "./Pages/DAR/EmployeesGraph/EmployeesGraph";
import GlobalNotFoundPage from "./Pages/GlobalNotFoundPage/GlobalNotFoundPage";
import AppraisalRoute from "./routes/AppraisalRoute";

function App() {
  // localStorage.setItem("BaseUrl", "http://103.8.43.34:2934");
  // localStorage.setItem("BaseUrl", "https://5b56-103-8-43-34.ngrok-free.app");
  localStorage.setItem("BaseUrl", process.env.REACT_APP_BASE_URL);

  const AppraisalWrapper = () => <Outlet />;
  const AttendanceWrapper = () => <Outlet />;
  const ProjectsWrapper = () => <Outlet />;
  const TrainingWrapper = () => <Outlet />;
  const ITEquipmentWrapper = () => <Outlet />;
  const ReimbursementWrapper = () => <Outlet />;
  const ResignationInfoWrapper = () => <Outlet />;

  return (
    <UserDataContextProvider>
      <BrowserRouter>
        {/* loading screen code */}
        <Suspense fallback={<AppLoader />}>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route
              path="/Dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/HumanResource"
              element={
                <ProtectedRoute>
                  <HumanResource />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lndividualTargetDetails"
              element={
                <ProtectedRoute>
                  <EmployeeTarget />
                </ProtectedRoute>
              }
            />
            <Route
              path="/HolidayList"
              element={
                <ProtectedRoute>
                  <HolidayList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/KnowledgeShare"
              element={
                <ProtectedRoute>
                  <KnowledgeShare />
                </ProtectedRoute>
              }
            />
            <Route
              path="/HR"
              element={
                <ProtectedRoute>
                  <HR />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AddEmployee"
              element={
                <ProtectedRoute>
                  <AddEmployee />
                </ProtectedRoute>
              }
            />
            <Route
              path="/EditEmployee"
              element={
                <ProtectedRoute>
                  <EditEmployee />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewEmployee"
              element={
                <ProtectedRoute>
                  <ViewEmployee />
                </ProtectedRoute>
              }
            />
            <Route
              path="/EmpProduct"
              element={
                <ProtectedRoute>
                  <EmpProduct />
                </ProtectedRoute>
              }
            />
            <Route
              path="/HrEmpDesig"
              element={
                <ProtectedRoute>
                  <HrEmpDesig />
                </ProtectedRoute>
              }
            />
            <Route
              path="/HREmpDept"
              element={
                <ProtectedRoute>
                  <HrEmpDepart />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ManageHoliday"
              element={
                <ProtectedRoute>
                  <ManageHoliday />
                </ProtectedRoute>
              }
            />
            <Route
              path="/HrEmpTargetList"
              element={
                <ProtectedRoute>
                  <EmpTarget />
                </ProtectedRoute>
              }
            />
            <Route
              path="/HrEmpTarget"
              element={
                <ProtectedRoute>
                  <TargetEdit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/DarSummary"
              element={
                <ProtectedRoute>
                  <DARSummary />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AddDar"
              element={
                <ProtectedRoute>
                  <AddDar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewDar"
              element={
                <ProtectedRoute>
                  <ViewDar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/EditDar"
              element={
                <ProtectedRoute>
                  <EditDar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ContinueDar"
              element={
                <ProtectedRoute>
                  <ContinueDar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/CustList"
              element={
                <ProtectedRoute>
                  <CustList />
                </ProtectedRoute>
              }
            />
            {/* <Route
              path="/CustList/PSGCustList"
              element={
                <ProtectedRoute>
                  <CustListISR />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path="/modifyCust"
              element={
                <ProtectedRoute>
                  <AddCust />
                </ProtectedRoute>
              }
            />
            <Route
              path="/EditCustomer"
              element={
                <ProtectedRoute>
                  <EditCust />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewCustomer"
              element={
                <ProtectedRoute>
                  <ViewCust />
                </ProtectedRoute>
              }
            />
            <Route
              path="/CustContact"
              element={
                <ProtectedRoute>
                  <CustContact />
                </ProtectedRoute>
              }
            />
            <Route
              path="/CreateQuotation"
              element={
                <ProtectedRoute>
                  <CreateQuotation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/FormQuotation"
              element={
                <ProtectedRoute>
                  <FormQuotation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/QuotationList"
              element={
                <ProtectedRoute>
                  <QuotationList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Pdfhtml"
              element={
                <ProtectedRoute>
                  <Pdfhtml />
                </ProtectedRoute>
              }
            />
            <Route
              path="/HrEmployeeList"
              element={
                <ProtectedRoute>
                  <HrEmployeeList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AdmPrincipal"
              element={
                <AdminRoute>
                  <AdmPrincipal />
                </AdminRoute>
              }
            />
            <Route
              path="/AdmProduct"
              element={
                <AdminRoute>
                  <AdmProduct />
                </AdminRoute>
              }
            />
            <Route
              path="/AdmProductOperation"
              element={
                <AdminRoute>
                  <AdmProductOperation />
                </AdminRoute>
              }
            />
            <Route
              path="/AdmProductOperation/Edit"
              element={
                <AdminRoute>
                  <AdmEditProductOperation />
                </AdminRoute>
              }
            />
            <Route
              path="/HrEmployeeDepartment"
              element={
                <AdminRoute>
                  <EmployeeDepartment />
                </AdminRoute>
              }
            />
            <Route
              path="/HrEmployeeDesignation"
              element={
                <AdminRoute>
                  <EmployeeDesignation />
                </AdminRoute>
              }
            />
            <Route
              path="/HrChangePassword"
              element={
                <AdminRoute>
                  <EmpChangePassword />
                </AdminRoute>
              }
            />
            <Route
              path="/AdmBranchPrincipalTargetList"
              element={
                <AdminRoute>
                  <AdmBranchPrincipalTargetList />
                </AdminRoute>
              }
            />
            <Route
              path="/AdmPrincipalTargetList"
              element={
                <AdminRoute>
                  <AdmPrincipalTargetList />
                </AdminRoute>
              }
            />
            <Route
              path="/PrincipalTarget"
              element={
                <AdminRoute>
                  <PrincipalTarget />
                </AdminRoute>
              }
            />
            <Route
              path="/AdmQuarterMasterList"
              element={
                <AdminRoute>
                  <QuarterMaster />
                </AdminRoute>
              }
            />
            <Route
              path="/AdmQuarterMaster"
              element={
                <AdminRoute>
                  <AddQuarterMaster />
                </AdminRoute>
              }
            />
            <Route
              path="/AdmPrincipalQuarterNameList"
              element={
                <AdminRoute>
                  <AdmPrincipalQuarterName />
                </AdminRoute>
              }
            />
            <Route
              path="/AdmPrincipalQuarter"
              element={
                <AdminRoute>
                  <AdmPrincipalQuarter />
                </AdminRoute>
              }
            />
            <Route
              path="/AdmPrincipalQuarter/Edit"
              element={
                <AdminRoute>
                  <AdmPrincipalQuarterNameEdit />
                </AdminRoute>
              }
            />
            {/* only static is done for this route, do not include this for now */}
            {/* <Route 
              path="/ActivityArea" element={
                <AdminRoute>
                  <ActivityArea />
                </AdminRoute>
              }
            /> */}
            <Route
              path="/AdmBranchPrincipalTarget"
              element={
                <AdminRoute>
                  <AdmBranchPrincipalTarget />
                </AdminRoute>
              }
            />
            <Route
              path="/OrderDefault"
              element={
                <ProtectedRoute>
                  <OrderDefault />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OrderGenerateList"
              element={
                <ProtectedRoute>
                  <OrderGenerateList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/EmployeeTarget"
              element={
                <ProtectedRoute>
                  <IndividualTarget />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OrderProcessedList"
              element={
                <ProtectedRoute>
                  <OrderProcessedList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OrderGenerate"
              element={
                <ProtectedRoute>
                  <OrderGenerate />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OrderProcessed"
              element={
                <ProtectedRoute>
                  <OrderProcessed />
                </ProtectedRoute>
              }
            />
            <Route
              path="/WeeklyActivity"
              element={
                <ProtectedRoute>
                  <WeeklyActivity />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OrderProcessDefault"
              element={
                <ProtectedRoute>
                  <OrderProcessDefault />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OrderList/OPUApproval"
              element={
                <ProtectedRoute>
                  <OPUApproval />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OPUApprovalEdit"
              element={
                <ProtectedRoute>
                  <OPUApprovalEdit />
                </ProtectedRoute>
              }
            />
            <Route
              path="EngineerConfirmationList"
              element={
                <ProtectedRoute>
                  <EngineerConfirmationList />
                </ProtectedRoute>
              }
            />
            <Route
              path="EngineerConfirmation"
              element={
                <ProtectedRoute>
                  <EngineerConfirmationEdit />
                </ProtectedRoute>
              }
            />
            {/* <Route 
            path="/OrderList/OrderPlaced"
            element={
              <ProtectedRoute>
                <PlaceOrder />
              </ProtectedRoute>
            }
          /> */}
            <Route
              path="/DailyActivityReport"
              element={
                <ProtectedRoute>
                  <ActivityReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AppDar"
              element={
                <ProtectedRoute>
                  <AppDar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/PriceList"
              element={
                <ProtectedRoute>
                  <PriceList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/LeaveDetail/EmployeeLeaveDetail"
              element={
                <ProtectedRoute>
                  <EmployeeLeaveDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/CurrencyMaster"
              element={
                <AdminRoute>
                  <CurrencyMaster />
                </AdminRoute>
              }
            />
            <Route
              path="/LeaveDetail/AddNewEmployeeLeave"
              element={
                <ProtectedRoute>
                  <AddNewEmployeeLeave />
                </ProtectedRoute>
              }
            />
            <Route
              path="/LeaveDetail/SubordinateLeaveHistory"
              element={
                <ProtectedRoute>
                  <SubordinateLeaveHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/LeaveDetail/EmployeesLeaveRecord"
              element={
                <ProtectedRoute>
                  <EmployeesLeaveRecord />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Dar/EmployeesGraph"
              element={
                <ProtectedRoute>
                  <EmployeesGraph />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AdmModule"
              element={
                <ProtectedRoute>
                  <ModuleMaster />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AdmModule/Add"
              element={
                <ProtectedRoute>
                  <AddModuleMaster />
                </ProtectedRoute>
              }
            />
            <Route
              path="/WeeklyReport"
              element={
                <ProtectedRoute>
                  <WeeklyReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Order/Details/List"
              element={
                <ProtectedRoute>
                  <OrderDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Order/Details"
              element={
                <ProtectedRoute>
                  <AddOrderDetails />
                </ProtectedRoute>
              }
            />
            {/* IT Equipment routes */}
            <Route path="/ITEquipment" element={<ITEquipmentWrapper />}>
              <Route
                index
                element={
                  <ProtectedRoute>
                    <ITEquipment />
                  </ProtectedRoute>
                }
              />
              <Route
                path="AddSystem"
                element={
                  <ProtectedRoute>
                    <AddSystemProperty />
                  </ProtectedRoute>
                }
              />
              <Route
                path="ViewSystem"
                element={
                  <ProtectedRoute>
                    <ViewSystemDetail />
                  </ProtectedRoute>
                }
              />

              <Route
                path="EditSystem"
                element={
                  <ProtectedRoute>
                    <EditSystemDetail />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* training routes */}
            <Route path="/Training" element={<TrainingWrapper />}>
              <Route index element={<Navigate to="/Dashboard" />} />
              <Route
                path="Schedule"
                element={
                  <ProtectedRoute>
                    <NewTraining />
                  </ProtectedRoute>
                }
              />

              <Route
                path="Suggestions"
                element={
                  <ProtectedRoute>
                    <Suggestions />
                  </ProtectedRoute>
                }
              />

              <Route
                path="Feedback"
                element={
                  <ProtectedRoute>
                    <Feedback />
                  </ProtectedRoute>
                }
              />

              <Route
                path="Details"
                element={
                  <ProtectedRoute>
                    <TrainingDetails />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* project routes */}
            <Route path="/Projects" element={<ProjectsWrapper />}>
              <Route index element={<Navigate to="/Dashboard" />} />
              <Route
                path="ManageProject"
                element={
                  <ProtectedRoute>
                    <ManageProject />
                  </ProtectedRoute>
                }
              />
              <Route
                path="ProjectAllocation"
                element={
                  <ProtectedRoute>
                    <ProjectAllocation />
                  </ProtectedRoute>
                }
              />

              <Route
                path="AssignedProject"
                element={
                  <ProtectedRoute>
                    <AssignedProject />
                  </ProtectedRoute>
                }
              />
              <Route
                path="ApprovedActivity"
                element={
                  <ProtectedRoute>
                    <ApproveActivity />
                  </ProtectedRoute>
                }
              />

              <Route
                path="ActivityStatus"
                element={
                  <ProtectedRoute>
                    <ActivityStatus />
                  </ProtectedRoute>
                }
              />
              <Route
                path="Reports"
                element={
                  <ProtectedRoute>
                    <ProjectReport />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* attendance routes */}
            <Route path="/Attendance" element={<AttendanceWrapper />}>
              <Route
                index
                element={
                  <ProtectedRoute>
                    <UserAttendanceList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="MarkAttendance"
                element={
                  <ProtectedRoute>
                    <MarkAttendance />
                  </ProtectedRoute>
                }
              />

              <Route
                path="AttendanceList"
                element={
                  <ProtectedRoute>
                    <AttendanceList />
                  </ProtectedRoute>
                }
              />

              <Route
                path="RequestLeave"
                element={
                  <ProtectedRoute>
                    <LeaveRequest />
                  </ProtectedRoute>
                }
              />

              <Route
                path="LeaveHistory"
                element={
                  <ProtectedRoute>
                    <LeaveHistory />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* appraisal routes */}
            <Route path="/Appraisal" element={<AppraisalWrapper />}>
              <Route index element={<Navigate to="/Dashboard" />} />
              <Route
                path="AssignEmployee"
                element={
                  <AppraisalRoute>
                    <AssignEmployee />
                  </AppraisalRoute>
                }
              />
              <Route
                path="3"
                element={
                  <ProtectedRoute>
                    <BackOfficeAppraisalForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="1"
                element={
                  <ProtectedRoute>
                    <PSGAppraisalForm />
                  </ProtectedRoute>
                }
              />

              <Route
                path="2"
                element={
                  <ProtectedRoute>
                    <MEAppraisalForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="5"
                element={
                  <ProtectedRoute>
                    <FAEappraisalForm />
                  </ProtectedRoute>
                }
              />

              <Route
                path="ManagerAuditEmpList"
                element={
                  <ProtectedRoute>
                    <ManagerAudit />
                  </ProtectedRoute>
                }
              />
              <Route
                path="SentReviewForm"
                element={
                  <AppraisalRoute>
                    <SentReviewForm />
                  </AppraisalRoute>
                }
              />
              <Route
                path="Not-Found"
                element={
                  <ProtectedRoute>
                    <AppraisalNotFound />
                  </ProtectedRoute>
                }
              />

              <Route
                path="AppraisalDetails"
                element={
                  <ProtectedRoute>
                    <AppraisalDetail />
                  </ProtectedRoute>
                }
              />

              <Route
                path="EmpAppraisalForm"
                element={
                  <ProtectedRoute>
                    <EmpAppraisalForm />
                  </ProtectedRoute>
                }
              />

              <Route
                path="HrReview"
                element={
                  <AppraisalRoute>
                    <HrReview />
                  </AppraisalRoute>
                }
              />

              <Route
                path="CeoReview"
                element={
                  <ProtectedRoute>
                    <CeoReview />
                  </ProtectedRoute>
                }
              />

              <Route
                path="CeoViewAppraisalForm"
                element={
                  <ProtectedRoute>
                    <CeoViewAppraisalForm />
                  </ProtectedRoute>
                }
              />

              <Route
                path="HrFinalReview"
                element={
                  <AppraisalRoute>
                    <HrFinalReview />
                  </AppraisalRoute>
                }
              />

              <Route
                path="HrViewEmpAppraisalForm"
                element={
                  <ProtectedRoute>
                    <HrEmpViewAppraisalForm />
                  </ProtectedRoute>
                }
              />

              <Route
                path="SendLetter"
                element={
                  <ProtectedRoute>
                    <SendLetter />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="Projects/ManageProjectType"
              element={
                <ProtectedRoute>
                  <ManageProjectType />
                </ProtectedRoute>
              }
            />
            <Route path="UserResetPassword" element={<ResetPassword />} />
            {/* reimbursement routes */}
            <Route path="/Reimbursement" element={<ReimbursementWrapper />}>
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <Reimbursement />
                  </ProtectedRoute>
                }
              />

              <Route
                path="List"
                element={
                  <ProtectedRoute>
                    <ReimbursementList />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="MailModel" element={<MailModels />} />
            <Route
              path="ManagerKRAapproval"
              element={
                <ProtectedRoute>
                  <ManagerKRAapproval />
                </ProtectedRoute>
              }
            />
            <Route
              path="MyKRAForm"
              element={
                <ProtectedRoute>
                  <MyKRA />
                </ProtectedRoute>
              }
            />
            <Route
              path="ReportingHeadConfirmation"
              element={
                <ProtectedRoute>
                  <ReportingHeadConfirmation />
                </ProtectedRoute>
              }
            />
            <Route
              path="EmpConfirmation"
              element={
                <ProtectedRoute>
                  <EmpConfirmation />
                </ProtectedRoute>
              }
            />
            <Route
              path="HRLeave&latecomingconfirmation"
              element={
                <ProtectedRoute>
                  <HRleaveandattendenceConfirmation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Confirmation/CheckProbation"
              element={
                <ProtectedRoute>
                  <CheckProbation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewDeviceInfo"
              element={
                <ProtectedRoute>
                  <ViewDeviceInfo />
                </ProtectedRoute>
              }
            />
            <Route
              path="/SubordinatesInfo"
              element={
                <ProtectedRoute>
                  <SubordinatesInfo />
                </ProtectedRoute>
              }
            />
            <Route
              path="/CustomerMaster"
              element={
                <ProtectedRoute>
                  <CustomerMaster />
                </ProtectedRoute>
              }
            />
            <Route
              path="/UserSideSystemView"
              element={
                <ProtectedRoute>
                  <UserSidesystemDetailView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/DAR/ActivityStatus"
              element={
                <ProtectedRoute>
                  <DARActivityStatus />
                </ProtectedRoute>
              }
            />
            DARActivityMailMaster
            <Route
              path="/DARActivityMailMaster"
              element={
                <ProtectedRoute>
                  <DARActivityMailMaster />
                </ProtectedRoute>
              }
            />
            {/* company routes */}
            {/* <Route path="/Company" element={<CompanyWrapper />}>
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <CompanyList />
                  </ProtectedRoute>
                }
              />

              <Route
                path="Add"
                element={
                  <ProtectedRoute>
                    <AddCompany />
                  </ProtectedRoute>
                }
              />
            </Route> */}
            <Route
              path="/Analytics/Orders"
              element={
                <ProtectedRoute>
                  <OrderAnalytics />
                </ProtectedRoute>
              }
            />
            {/* resignation info routes */}
            <Route path="/ResignationInfo" element={<ResignationInfoWrapper />}>
              <Route
                path="ReportingHeadList"
                element={
                  <ProtectedRoute>
                    <ReportingHeadList />
                  </ProtectedRoute>
                }
              />

              <Route
                path="ResignationStatus"
                element={
                  <ProtectedRoute>
                    <UserResignationStatus />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/QPI" element={<Outlet />}>
              <Route
                path=""
                element={
                  <ProtectedRoute>
                    <QPI />
                  </ProtectedRoute>
                }
              />
              <Route
                path="List"
                element={
                  <ProtectedRoute>
                    <QPIList />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* <Route 
              path="QPI"
              element={
                <ProtectedRoute>
                  <QPI />
                </ProtectedRoute>
              }
            /> */}
            <Route path="/Order/Pipeline" element={<Outlet />}>
              <Route
                path="Create"
                element={
                  <ProtectedRoute>
                    <OrderPipeline />
                  </ProtectedRoute>
                }
              />
              <Route
                path="List"
                element={
                  <ProtectedRoute>
                    <OrderPipelineList />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/ReviewPortal"
              element={
                <ProtectedRoute>
                  <ReviewPortal />
                </ProtectedRoute>
              }
            />
            <Route
              path="/TargetsOverview"
              element={
                <ProtectedRoute>
                  <TargetsOverview />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewActivityreport"
              element={
                <ProtectedRoute>
                  <ViewActivityReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Forecast"
              element={
                <ProtectedRoute>
                  <Forecast />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Forecast/MEDDIC"
              element={
                <ProtectedRoute>
                  <Meddic />
                </ProtectedRoute>
              }
            />
            <Route path="/IncentiveMaster" element={<Outlet />}>
              <Route
                path="ExtraIncentive"
                element={
                  <ProtectedRoute>
                    <ExtraIncentive />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/ApproveWeeklyActivity"
              element={
                <ProtectedRoute>
                  <ApproveWeeklyActivity />
                </ProtectedRoute>
              }
            />
            <Route path="/Performance" element={<Outlet />}>
              <Route
                path="Overview"
                element={
                  <ProtectedRoute>
                    <PerformanceOverview />
                  </ProtectedRoute>
                }
              />
              <Route
                path="Team"
                element={
                  <ProtectedRoute>
                    <EmployeeList />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="*" element={<GlobalNotFoundPage />}></Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </UserDataContextProvider>
  );
}

export default App;
